import { isMobile } from '../../util';

const MenuBanner = ({
    accountId, sourceId, retailerId, placementId, category, slider
}) => {
    if (category) {
        return (
            <div className='surfside-menu-banner surfside-category-banner'>
                <div
                    className='surf-ad-placement'
                    accountid={accountId}
                    channelid='bf9bc'
                    siteid={sourceId}
                    placementid={placementId}
                    storeId={retailerId}
                    location-id={retailerId}
                    keywords={category}
                    zone='menu'
                    type='inline'
                    adtypes='0,1'
                    width={isMobile() ? "4" : "8"}
                    height={1}
                >
                </div>
                <surf-banner
                    className='surf-ad-placement'
                    account-id={accountId}
                    channel-id="bf9bc"
                    site-id={sourceId}
                    placement-id={placementId}
                    location-id={retailerId}
                    keywords={category}
                    zone='menu'
                    type='inline'
                    adtypes='0,1'
                    width={isMobile() ? "4" : "8"}
                    height={1}
                ></surf-banner>
            </div>
        );
    } else {
        return slider ? (
            <div className='surfside-menu-banner'>
                <surf-banner
                    className='surf-ad-placement'
                    account-id={accountId}
                    channel-id="bf9bc"
                    site-id={sourceId}
                    placement-id={placementId}
                    location-id={retailerId}
                    keywords='menu'
                    zone='menu'
                    type='inline'
                    adtypes='0,1'
                    width={4}
                    height={1}
                ></surf-banner>
            </div>
        ) : (
            <div className='surfside-menu-banner menu-surfside-banner'>
                <surf-banner
                    className='surf-ad-placement'
                    account-id={accountId}
                    channel-id="bf9bc"
                    site-id={sourceId}
                    placement-id={placementId}
                    location-id={retailerId}
                    keywords='menu'
                    zone='menu'
                    type='inline'
                    adtypes='0,1'
                    width={isMobile() ? "4" : "8"}
                    height={1}
                ></surf-banner>
            </div>
        );
    }
};

export default MenuBanner;
